import {
  ResponsiveCard,
  ResponsiveCardProps,
  useTabsTabIndexReset,
} from '@framework/ui';
import styled from 'styled-components';

const StyledSubmissionResponsiveCard = styled(ResponsiveCard)`
  &&& {
    // solo se c'è una cover vuota
    .ant-card-cover:empty + .ant-card-body {
      /* padding-top: 0; */
    }

    .ant-card-head + .ant-card-body {
      /* padding-top: 0; */
    }
    // corretto padding del body quando la card contiene tabs
    &.ant-card-contain-tabs {
      .ant-card-head + .ant-card-body {
        /* padding-top: 24px; */
      }
    }
    // corretto padding del body quando la card contiene tabs
    &.ant-card-contain-tabs {
      .ant-card-head .ant-tabs > .ant-tabs-nav .ant-tabs-tab {
        padding-bottom: 12px;
      }
    }
  }
`;
export const SubmissionCardTabsPrefix = 'submission-card-tabs-';

export interface SubmissionResponsiveCardProps extends ResponsiveCardProps {}

/**
 * ResponsiveCard personalizzata della richiesta
 */
export function SubmissionResponsiveCard(props: SubmissionResponsiveCardProps) {
  useTabsTabIndexReset(
    props.tabList,
    props.activeTabKey ?? 'key',
    SubmissionCardTabsPrefix,
  );
  return <StyledSubmissionResponsiveCard {...props} />;
}
